var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flicking-wrapper"},[_c('flicking',_vm._b({ref:"flicking"},'flicking',_vm.attrs,false),[_vm._t("default",null,{"attrs":{
        class: 'flicking-panel'
      }})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }